import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';

import { UsuarioEmailAdministrativoFormComponent } from './usuario-email-administrativo-form.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        UsuarioEmailAdministrativoFormComponent
    ],
    exports: [
        UsuarioEmailAdministrativoFormComponent
    ]
})
export class UsuarioEmailAdministrativoFormModule { }
